import { PixelMeasurements } from './pixel-measurements.model';

export class PixelPosition2D extends PixelMeasurements {
  public readonly x: string;
  public readonly y: string;

  constructor(x: number, y: number, centimeterToPixelRatio: number) {
    super(centimeterToPixelRatio);
    this.x = this.toPixels(x);
    this.y = this.toPixels(y);
  }

  get xNumber(): number {
    return parseInt(this.x.slice(0, -2), 10);
  }

  get yNumber(): number {
    return parseInt(this.y.slice(0, -2), 10);
  }
}
